/**
 * Company Communications tab — info-popover tooltip content (JSX).
 * Kept in a `.tsx` sibling of `constants/index.ts` (JSX can't live in the `.ts` barrel);
 * re-exported through `../constants`.
 */

/** Reports Reminder Frequency — was inline yellow note; now green (i) on section title. */
export const TOOLTIP_REPORTS_FREQUENCY = (
    <p className="m-0">
        <span className="font-medium text-slate-900">Note: </span>
        Reports are available on Fridays. Monthly on the last Thursday of the month to show the past month&apos;s
        performance. Weekly to see performance for the week.
    </p>
)

/** “Default Update Notification Preferences” help — green (i) on section title (wide, horizontal-leaning layout in popover). */
export const TOOLTIP_DEFAULT_UPDATE_NOTIFICATIONS = (
    <div className="w-[min(40rem,calc(100vw-1.5rem))] max-w-full text-pretty">
        <p className="mb-3 m-0 sm:mb-2">
            This section is to help improve communications to your Communities and Company staff. The following
            reminders will automatically go to the Community Managers regardless of any other settings you add here. The
            other two options that can be added are:
        </p>
        <div className="mb-3 grid grid-cols-1 gap-3 sm:mb-2 sm:grid-cols-2 sm:items-start sm:gap-x-5 sm:gap-y-2">
            <p className="m-0 min-w-0 sm:border-0 sm:pe-2 md:border-r md:border-slate-200/80">
                <span className="font-semibold text-slate-800">1. Designated Company Contact</span>
                <span className="text-slate-800"> — </span>
                an individual you want to be notified in these cases (e.g. COO, or Company Admin). Alternatively, you
                may set up an individual with a group mailbox so others are notified from your mail system.
            </p>
            <p className="m-0 min-w-0">
                <span className="font-semibold text-slate-800">2. Regional Managers</span>
                <span className="text-slate-800"> — </span>
                roles linked to specific Communities. You do not identify them here; specify that you want a notice to go
                to them and we will add them to the email automatically. You only designate which notice and date to
                send.
            </p>
        </div>
        <p className="m-0 border-t border-amber-200/80 pt-2 sm:pt-2.5">
            <span className="font-medium text-slate-800">Note: </span>
            To help your staff receive our emails, have your IT add our system address (Notifications@libertyrent.io) to
            the email server &quot;Safe Sender&quot; list.
        </p>
    </div>
)

export const TOOLTIP_RESIDENT_PAID_INTRO = (
    <p className="m-0">
        This set of notices is to remind Community Managers to mark Liberty-backed residents as &quot;Paid&quot; (or
        &quot;Not&quot;) for each month so the Default process starts in a timely manner when needed. Standard send dates
        are preset; you can change them to fit your operations. You can include Regional Managers and/or your Designated
        Company Contact on the reminders.
    </p>
)

export const TOOLTIP_ACTIVE_DEFAULTS_INTRO = (
    <p className="m-0">
        These notices remind Community Managers to update information on active Defaults or Skips to complete filing and
        recover lost rent. Adjust reminder dates and add contacts for each notice as above.
    </p>
)
